import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import styled from 'styled-components';
import { SidebarContainer } from '../common/SidebarContainer';
import { Aggregation } from '../../shop/language/bundles/bundleCategories';
import { useTranslation } from 'react-i18next';

const StyledSidebarContainer = styled(SidebarContainer)`
    a:not(.active):not(:hover) {
        color: #000000;
    }
`;

type Props = {
    readonly categories?: string;
    readonly releaseYear?: string;
    readonly bundleCategories: {
        releaseYear?: Aggregation;
        categories?: Aggregation;
        totalCount: number;
    };
    readonly buildUrlPath: (item?: { name: string; value: string }) => string;
};

export const ListCategories: FC<Props> = props => {
    const { t } = useTranslation();
    const { bundleCategories: aggregations, buildUrlPath } = props;

    let categoryClasses = classNames({
        active: !props.categories && !props.releaseYear
    });

    const categories = aggregations.categories;
    const releaseYear = aggregations.releaseYear;

    return (
        <StyledSidebarContainer>
            <div className="fe">
                <div className="filter-label">
                    <Link to={buildUrlPath()} className={categoryClasses}>
                        {t('allContentSelections')}{' '}
                        <span className="count">
                            ({t('numberFormat.numberWithoutDecimalPoint', { val: aggregations.totalCount })})
                        </span>
                    </Link>
                </div>
            </div>
            <div className="filter-items">
                {releaseYear && releaseYear.buckets ? (
                    <>
                        <div className="fe" style={{ marginTop: '0px' }} key="releases">
                            <div className="filter-label">{t('shop.catalogue.productGroup.newReleases')}</div>
                        </div>
                        {releaseYear.buckets.map((year, i) => {
                            const clazz = classNames({
                                active: props.releaseYear === year.key
                            });
                            return (
                                <div className="fe" key={i}>
                                    <div className="filter-label" style={{ paddingLeft: '15px' }}>
                                        <Link
                                            to={buildUrlPath({ name: 'releaseYear', value: year.key })}
                                            className={clazz}
                                        >
                                            {year.key}{' '}
                                            <span className="count">
                                                ({t('numberFormat.numberWithoutDecimalPoint', { val: year.docCount })})
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            );
                        })}
                    </>
                ) : null}
            </div>
            <div className="filter-items">
                {categories && categories.buckets
                    ? categories.buckets.map((category, i) => {
                          const clazz = classNames({
                              active: props.categories === category.key
                          });
                          return (
                              <div className="fe" key={i}>
                                  <div className="filter-label">
                                      <Link
                                          to={buildUrlPath({ name: 'categories', value: category.key })}
                                          className={clazz}
                                      >
                                          {category.key}{' '}
                                          <span className="count">
                                              ({t('numberFormat.numberWithoutDecimalPoint', { val: category.docCount })}
                                              )
                                          </span>
                                      </Link>
                                  </div>
                              </div>
                          );
                      })
                    : null}
            </div>
        </StyledSidebarContainer>
    );
};
